import { createSlice } from '@reduxjs/toolkit';

import { INewsItem, INewsTitle, Pager, RequestStatusTypes } from 'models';

import { apiReducerBuilder } from 'utils';

import {
	getNews,
	getNewsTitles,
	getNewsTitlesMore,
	getPieceOfNews,
	markAsRead,
	markAsUnread,
} from './actions';
import { readAllNews } from './actions/readAllNews';

interface News {
	news: INewsItem[];
	titles: INewsTitle[];
	newsItem: INewsItem;
	status: RequestStatusTypes;
	pager: Pager;
	pagerTitles: Pager;
}

const findNewsItemById = (state: News, newsUuid: string) => {
	const newsItem = state.titles.find((item) => item.id === newsUuid);
	const newsItemTwo = state.news.find((item) => item.id === newsUuid);
	return { newsItem, newsItemTwo };
};

const markAllAsRead = (items: (INewsTitle | INewsItem)[]) => {
	return items.map((item) => ({ ...item, read: true }));
};

const NewsSlice = createSlice({
	name: 'news',
	initialState: {
		titles: [] as INewsTitle[],
		news: [] as INewsItem[],
		newsItem: {} as INewsItem,
		pager: {} as Pager,
		pagerTitles: {} as Pager,
	} as News,
	reducers: {},
	extraReducers: (builder) => {
		apiReducerBuilder(builder, getNewsTitles, (state, action) => {
			const { payload, meta } = action;
			state.titles = payload.items;
			state.pagerTitles = payload.pager;
			state.status = meta.requestStatus;
		});

		apiReducerBuilder(builder, getNewsTitlesMore, (state, action) => {
			const { payload, meta } = action;
			state.titles = [...state.titles, ...payload.items];
			state.pagerTitles = payload.pager;
			state.status = meta.requestStatus;
		});

		apiReducerBuilder(builder, getNews, (state, action) => {
			const { payload, meta } = action;
			state.news = payload.items;
			state.pager = payload.pager;
			state.status = meta.requestStatus;
		});

		apiReducerBuilder(builder, getPieceOfNews, (state, action) => {
			const { payload, meta } = action;

			state.newsItem = payload;
			state.status = meta.requestStatus;

			const newsItemTitle = state.titles.find((item: INewsTitle) => item.id === meta.arg.newsUuid);

			if (newsItemTitle) {
				newsItemTitle.read = true;
			}
		});

		apiReducerBuilder(builder, readAllNews, (state, action) => {
			const { meta } = action;

			state.titles = markAllAsRead(state.titles);
			state.news = markAllAsRead(state.news);

			state.status = meta.requestStatus;
		});

		apiReducerBuilder(builder, markAsRead, (state, action) => {
			const { meta } = action;
			const newsUuid = meta.arg.newsUuid;

			const { newsItem, newsItemTwo } = findNewsItemById(state, newsUuid);

			if (newsItem) newsItem.read = true;
			if (newsItemTwo) newsItemTwo.read = true;

			state.status = meta.requestStatus;
		});

		apiReducerBuilder(builder, markAsUnread, (state, action) => {
			const { meta } = action;

			const newsUuid = meta.arg.newsUuid;

			const { newsItem, newsItemTwo } = findNewsItemById(state, newsUuid);

			if (newsItem) newsItem.read = false;
			if (newsItemTwo) newsItemTwo.read = false;

			state.status = meta.requestStatus;
		});
	},
});

export default NewsSlice.reducer;
